/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customerDataSchema = z.object({
	id: z.string(),
	name: z.string().nullable(),
	email: z.string().nullable(),
	address: z.object({
		line1: z.string().nullable(),
		line2: z.string().nullable(),
		city: z.string().nullable(),
		state: z.string().nullable(),
		postalCode: z.string().nullable(),
		country: z.string().nullable(),
	}),
	tax: z.object({
		registered: z.boolean(),
		data: z.object({
			id: z.string(),
			value: z.string(),
			verification: z.union([
				z.literal('pending'),
				z.literal('unavailable'),
				z.literal('unverified'),
				z.literal('verified'),
			]),
		}).nullable(),
		taxRate: z.object({ percentage: z.number(), displayName: z.string() }),
		showWarning: z.boolean(),
		preventPurchase: z.boolean(),
	}),
	paymentOverview: z.object({
		paymentTerms: z.number(),
		credits: z.number(),
		card: z.object({
			id: z.string(),
			brand: z.string(),
			last4: z.string(),
			expMonth: z.number(),
			expYear: z.number(),
		}).nullable(),
	}).nullable(),
})

export type CustomerDataSchema = z.infer<typeof customerDataSchema>
